module.exports = __webpack_public_path__ + "assets/img/LTC001.f05b0628.png";